/* ============================================================
   CADENA GUADALUPE (slug 'guadalupe') — cadena de dama + dije de la Virgen
   de Guadalupe en oro laminado 18K.

   Producto Shopify "CADENA GUCCI DE DAMA + VRG GUADALUPE" (8686428553377).
   Cada combo es UNA variante per-unit con el MISMO SKU CAD-958 (el que Dropi
   ya tiene mapeado), y la landing manda quantity = N:
     1 Cadena  -> $99.900 x 1 = $99.900
     2 Cadenas -> $79.950 x 2 = $159.900
     3 Cadenas -> $73.300 x 3 = $219.900
   Así el total cuadra con lo que muestra la landing Y el pedido lleva las
   unidades reales para que Dropi despache la cantidad correcta.
   Requiere quantityControlsHidden:true en Releasit (ya global) para que el
   cliente no pueda cambiar la cantidad y desarmar el precio.

   El HTML original mandaba a una CHECKOUT_URL pegada a mano; eso se reemplazó
   por el trigger nativo de Releasit (mismo patrón que las demás landings).
   Ver memory/project_releasit_cod_pattern y memory/project_bundles_as_variants.
   ============================================================ */
(function () {
  var root = document.querySelector('.guadalupe-landing');
  if (!root) return;

  /* ============================================================
     1. Galería del hero
     ============================================================ */
  window.setMain = function (el) {
    var main = document.getElementById('mainImg');
    if (main) main.src = el.src;
    root.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
    el.classList.add('active');
  };

  /* ============================================================
     2. Releasit COD — variante + cantidad en el DOM, click botón nativo
     ============================================================ */
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    // Releasit lee la cantidad de input[name="quantity"] al abrir el modal
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function clickNativeReleasit() {
    var rb = findReleasitButton();
    if (rb) { rb.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = findReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        // último recurso: abre el modal con la variante que Releasit cacheó
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }

  var lastVariantId = null, lastQty = 1;

  function triggerCOD(el) {
    var variantId = (el && el.getAttribute('data-bundle-variant-id')) || lastVariantId;
    var qty = (el && el.getAttribute('data-qty')) || lastQty;
    if (!variantId) return;
    lastVariantId = variantId;
    lastQty = qty;
    setVariantOnAllForms(variantId, qty);
    setTimeout(clickNativeReleasit, 50);
  }
  window.guadalupeTriggerCOD = triggerCOD;

  /* cada botón de la sección de oferta (.buy) lleva su propio combo */
  root.querySelectorAll('.buy').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      selectPick(a.getAttribute('data-qty'));
      triggerCOD(a);
    });
  });

  /* ============================================================
     3. Selector de combo del hero (v2) — .pick = radio; los .buy-selected
        (hero, sticky, CTA final) disparan el COD con el combo elegido
     ============================================================ */
  var picks = root.querySelectorAll('.pick');
  var selected = root.querySelector('.pick.is-on') || picks[picks.length - 1];

  function paintSelected() {
    if (!selected) return;
    var qty = selected.getAttribute('data-qty');
    var total = selected.getAttribute('data-total');
    var name = qty === '1' ? '1 Cadena' : qty + ' Cadenas';
    picks.forEach(function (p) {
      var on = p === selected;
      p.classList.toggle('is-on', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.querySelectorAll('.js-sel-total').forEach(function (el) { el.textContent = total; });
    root.querySelectorAll('.js-sel-name').forEach(function (el) { el.textContent = name; });
    root.querySelectorAll('.js-sel-label').forEach(function (el) { el.textContent = name + ' · ' + total; });
    lastVariantId = selected.getAttribute('data-bundle-variant-id');
    lastQty = qty;
    setVariantOnAllForms(lastVariantId, lastQty);
  }

  function selectPick(qty) {
    picks.forEach(function (p) { if (p.getAttribute('data-qty') === String(qty)) selected = p; });
    paintSelected();
  }

  picks.forEach(function (p) {
    p.addEventListener('click', function () { selected = p; paintSelected(); });
  });

  root.querySelectorAll('.buy-selected').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      triggerCOD(selected);
    });
  });

  /* init: combo más vendido (3 cadenas) */
  paintSelected();

  /* Barra sticky: aparece cuando el hero sale de pantalla */
  var sticky = document.getElementById('stickyCta');
  var hero = document.getElementById('hero');
  if (sticky && hero) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('show', hero.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  /* ============================================================
     4. Contador suave de stock
     ============================================================ */
  var stockEl = document.getElementById('stock');
  if (stockEl) {
    var stock = 17;
    setInterval(function () {
      if (stock > 6 && Math.random() > 0.6) {
        stock--;
        stockEl.textContent = 'Quedan ' + stock + ' unidades';
      }
    }, 12000);
  }
})();
